import { Language } from "../Constants/LanguageConstants";
import { SettingsModel, UpdateManifestPath } from "./SettingsModel";

export interface IDocumentManifestModel {
  documents: IDocumentModel[];
}

export interface IDocumentModel {
  id: string;
  title: string;
  file: string;
  language?: Language | string;
  content?: string;
}

export const DocumentManifestModel: IDocumentManifestModel = {
  documents: [],
};

export const InitManifestsModel = async (lang: Language) => {
  try {
    UpdateManifestPath(lang);

    const manifestData: IDocumentManifestModel = await fetch(
      `${process.env.PUBLIC_URL}${SettingsModel.manifestPath}`
    ).then((res) => res.json());

    DocumentManifestModel.documents = manifestData.documents;
  } catch (error) {
    console.error("Error loading document manifest:", error);
    return false;
  }
  return true;
};
